if (!customElements.get('custom-content')) {
  class CustomContent extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.scrollContainer = null;
      this.progressBar = null;
      this.scrollHandler = this.handleScroll.bind(this);
      this.resizeObserver = new ResizeObserver(this.updateProgressBar.bind(this));
    }

    connectedCallback() {
      if (this.initialized) return;
      
      this.scrollContainer = this.querySelector('.swipe-mobile__inner, .swipe-desktop__inner');
      
      if (!this.scrollContainer) return;
      
      // Check if progress bar is enabled in section settings
      const showProgressBar = this.getAttribute('data-show-progress-bar') !== 'false';
      console.log('Progress bar enabled:', showProgressBar);
      
      // Only create progress bar if enabled
      if (showProgressBar) {
        console.log('Creating progress bar...');
        this.createProgressBar();
      }
      
      // Initialize on next frame to ensure DOM is ready
      requestAnimationFrame(() => {
        this.initializeScrollTracking();
      });
      
      this.initialized = true;
    }

    createProgressBar() {
      console.log('createProgressBar called');
      // Create progress bar container
      const progressContainer = document.createElement('div');
      progressContainer.className = 'custom-content-progress-container';
      progressContainer.style.display = 'block';
      console.log('Progress container created:', progressContainer);
      progressContainer.style.cssText = `
        width: 100%;
        height: 4px;
        background-color: rgba(var(--color-foreground), 0.1);
        border-radius: 2px;
        overflow: hidden;
        margin-top: 1.5rem;
        position: relative;
      `;
      
      // Create progress bar
      this.progressBar = document.createElement('div');
      this.progressBar.className = 'custom-content-progress-bar';
      this.progressBar.style.cssText = `
        height: 100%;
        width: 10%; /* Initial progress */
        background-color: #EAB47D;
        transition: width 0.2s ease-out;
        position: absolute;
        top: 0;
        left: 0;
      `;
      
      progressContainer.appendChild(this.progressBar);
      
      // Insert progress bar after the scroll container
      this.scrollContainer.parentNode.insertBefore(progressContainer, this.scrollContainer.nextSibling);
      console.log('Progress bar inserted into DOM');
      
      // Add mobile class if needed
      if (this.scrollContainer.classList.contains('swipe-mobile__inner')) {
        progressContainer.classList.add('md:hidden');
      } else {
        progressContainer.classList.add('md:block');
      }
    }

    initializeScrollTracking() {
      if (!this.scrollContainer) return;
      
      // Set initial position
      this.updateProgressBar();
      
      // Add scroll event listener
      this.scrollContainer.addEventListener('scroll', this.scrollHandler, { passive: true });
      
      // Observe container for size changes
      this.resizeObserver.observe(this.scrollContainer);
      
      // Observe child elements for size changes
      Array.from(this.scrollContainer.children).forEach(child => {
        this.resizeObserver.observe(child);
      });
    }

    handleScroll() {
      if (!this.scrollContainer) return;
      requestAnimationFrame(this.updateProgressBar.bind(this));
    }

    updateProgressBar() {
      if (!this.scrollContainer || !this.progressBar) {
        console.log('updateProgressBar: Missing scrollContainer or progressBar', {
          hasScrollContainer: !!this.scrollContainer,
          hasProgressBar: !!this.progressBar
        });
        return;
      }
      
      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
      const maxScroll = Math.max(1, scrollWidth - clientWidth); // Ensure maxScroll is at least 1 to avoid division by zero
      const progress = Math.min(100, Math.max(10, (scrollLeft / maxScroll) * 100)); // Keep minimum 10% progress
      
      console.log('Updating progress:', { scrollLeft, scrollWidth, clientWidth, maxScroll, progress });
      this.progressBar.style.width = `${progress}%`;
    }

    disconnectedCallback() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.scrollHandler);
      }
      this.resizeObserver.disconnect();
    }
  }

  customElements.define('custom-content', CustomContent);
}
